export interface ColorSwatchProps {
  readonly value: string;
  readonly onChange: (color: string) => void;
  readonly label?: string;
}

export function ColorSwatch({ value, onChange, label }: ColorSwatchProps) {
  const safeHex = value?.startsWith('#') ? value.slice(0, 7) : '#ffffff';

  return (
    <div className="flex items-center overflow-hidden rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-body transition-colors focus-within:border-ctx-interactive-primary">
      <label className="relative flex shrink-0 cursor-pointer items-center self-stretch border-r-hairline border-ctx-layout-border pl-nano pr-nano">
        <div className="rounded-quark h-xxs w-xxs" style={{ backgroundColor: safeHex }} />
        <input
          type="color"
          value={safeHex}
          onChange={e => onChange(e.target.value)}
          className="absolute inset-none h-full w-full cursor-pointer opacity-transparent"
          aria-label={label ?? 'Cor'}
        />
      </label>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        className="min-w-none flex-1 border-none bg-base-neutral-none px-nano py-quark text-ctx-content-base outline-none ts-caption-xxs"
      />
    </div>
  );
}
